<template>
	<div class="dashboard-container">
		<el-tabs v-model="activeName" class="tas" type="card" @tab-click="handleClick">
			<el-tab-pane label="数据实况" name="first"></el-tab-pane>
			<el-tab-pane label="流量分析" name="two"></el-tab-pane>
			<el-tab-pane label="交易分析" name="three"></el-tab-pane>
		</el-tabs>
		<Hair v-if="activeName=='first'"></Hair>
		<Hair2 v-if="activeName=='two'"></Hair2>
		<Hair3 v-if="activeName=='three'"></Hair3>
	</div>
</template>
<script>
	import Hair from "./datalive/datalive1.vue"
	import Hair2 from "./datalive/datalive2.vue"
	import Hair3 from "./datalive/datalive3.vue"
	export default {
		components: {
			Hair,
			Hair2,
			Hair3
		},
		data() {
			this.chartSettings = {
				label: {
					normal: {
						show: false,
					}
				}
			}
			this.chartExtend = {
				color: ['#FB697E', '#845FFD']
			}
			return {
				activeName: 'first',
				show: false,
			}
		},
		methods: {
			handleClick(tab, event) {}
		}
	}
</script>

<style scoped="scoped" lang="less">
	.waititle {
		font-weight: bold;
		display: flex;
		font-size: 16px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #3e3e3e;

		.blue {
			width: 5px;
			position: relative;
			top: 3px;
			height: 15px;
			background: #409eff;
			border-radius: 2px;
			margin-right: 10px;
			margin-bottom: 20px;
		}
	}

	.dashboard-container {
		box-sizing: border-box;

		.showlist_top {
			width: 100%;
			height: 135px;
			display: flex;

			.showlist_top1 {
				box-sizing: border-box;
				padding: 20px;
				flex: 1;
				margin-left: 20px;
				background: #f2f2f2;
				border-radius: 6px;

				>div {
					&:nth-child(1) {
						font-size: 14px;
						font-family: Source Han Sans CN;
						font-weight: 400;
						color: #3e3e3e;
					}

					&:nth-child(2) {
						font-size: 20px;
						margin-top: 10px;
						font-size: 36px;
						font-family: Source Han Sans CN;
						font-weight: 400;
						color: #3e3e3e;
					}
				}

				.bili {
					margin-top: 10px;
					display: flex;
					font-size: 14px;

					>div {
						&:nth-child(2) {
							margin-left: 10px;
						}
					}
				}

				&:nth-child(1) {
					margin: 0;
				}
			}
		}

		//
		.showlist2s {
			width: 100%;
			padding: 4px;
			box-sizing: border-box;
		}

		.showlist2 {
			padding: 20px;
			box-sizing: border-box;
			margin-top: 20px;
			width: 100%;
			background: #ffffff;
			box-shadow: 0px 2px 9px 0px rgba(#0000, 0.09);

			.tubiao {
				margin-top: 20px;
			}

			.conversion {
				width: 100%;
				height: 100%;
				display: flex;

				.conversion_1 {
					flex: 1.8;
					position: relative;

					.conversion_1_list {
						display: flex;
						line-height: 32px;
						border-bottom: 1px solid #e7e7e7;
						padding-bottom: 20px;
						margin-top: 10px;

						&:nth-child(3) {
							border: none;
						}

						.lists {
							margin-left: 60px;
						}
					}

					//
					.loudou {
						width: 350px;
						top: 50%;
						margin-top: -225px;
						position: absolute;
						right: -200px;
					}
				}

				.conversion_2 {
					flex: 1;

					.xiantiao {
						width: 180px;
						height: 200px;
						margin-left: 50px;
						margin-top: 80px;
						position: relative;

						img {
							display: block;
							margin-left: 30px;
							width: 180px;
							height: 200px;
						}

						.rate {
							position: absolute;
							width: 200px;
							height: 180px;
							right: 0;
							top: 0;

							.rates {
								line-height: 2px;
							}

							.rate1 {
								top: 30px;
								right: -28px;
								position: absolute;
							}

							.rate2 {
								top: 110px;
								right: -28px;
								position: absolute;
							}

							.rate3 {
								top: 70px;
								right: -98px;
								position: absolute;
							}
						}
					}
				}
			}

			//
			.attributes_con {
				display: flex;

				.attributes_con1 {
					flex: 1;

					&:nth-child(1) {
						box-sizing: border-box;
					}
				}

				.shuxian {
					border-left: 1px solid #e7e7e7;
					height: 220px;
					margin-top: 50px;
				}

				.attributes_con2 {
					display: flex;

					>div {
						font-size: 18px;
						font-family: Source Han Sans CN;
						font-weight: 400;
						flex: 1;
						margin-top: 40px;
						text-align: center;

						>p {
							&:nth-child(1) {
								color: #9A9A9A;
							}

							margin-top: 40px;

						}
					}
				}

				.attributes_1 {
					display: flex;

					.con1_tu {
						flex: 1;
						display: flex;

						>div {
							flex: 1;
						}

						.con1_title {
							.con1_titles {
								padding-top: 80px;
								display: flex;

								.con1_title1 {
									display: flex;
									margin-right: 50px;
									margin-left: 40px;

									&:nth-child(1) {}

									.yuan_blue {
										width: 10px;
										height: 10px;
										background-color: blue;
										border-radius: 50%;
										margin-top: 3px;
										margin-right: 5px;
									}

								}
							}
						}
					}
				}
			}

			.attributes_bottom {
				position: relative;
				top: -20px;
			}
		}
	}

	.new_and_old_warp {
		margin-top: 25px;
	}

	.newolder {
		margin-top: 15px;
	}

	.newo {
		display: flex;
		width: 100%;
	}

	.newo1 {
		flex: 2;
	}

	.newo2_title {
		flex: 1;
	}

	.newo2 {
		flex: 3.5;
		margin-top: 50px;
	}

	.newo2_title {
		margin-top: 45px;
		margin-bottom: 45px;
		display: flex;
	}

	.newo2_title>div {
		box-sizing: border-box;
		display: flex;
		flex: 1;
		font-size: 16px;
		font-family: Source Han Sans CN;
		font-weight: 400;
		color: #3E3E3E;
	}

	.yuan1 {
		position: relative;
		top: 4px;
		left: -8px;
		width: 10px;
		height: 10px;
		background: #FB697E;
		border-radius: 50%;
	}

	.yuan2 {
		position: relative;
		top: 4px;
		left: -8px;
		width: 10px;
		height: 10px;
		background: #845FFD;
		border-radius: 50%;
	}

	.new2_table {
		box-sizing: border-box;
		padding-right: 20px;
	}

	.demo3 {
		margin-top: 20px;
		display: flex;
	}

	.demo3>div:nth-child(1) {
		flex: 3.2;
	}

	.demo3>div:nth-child(2) {
		flex: 2;
	}

	.demo3>div:nth-child(1) {
		margin-right: 20px;
	}
</style>